import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getDegreeOfSoilCatalog = state => state.models[name].data;
export const getCurDegreeOfSoil = state => state.models[name].item;